import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faGift, faSnowflake } from "@fortawesome/free-solid-svg-icons";
function ChristmasDelivery() {

  
  const christmasFeatures = [
    {
      title: "Fast & Reliable",
      description: "Ensure your gifts reach their destination on time...",
      icon: <FontAwesomeIcon icon={faClock} className="w-16 h-16 text-black" />,
    },
    {
      title: "Gift Wrapping Services",
      description: "Make your loved ones smile with beautifully wrapped presents...",
      icon: <FontAwesomeIcon icon={faGift} className="w-16 h-16 text-black" />,
    },
    {
      title: "Cold-Weather Ready",
      description: "No matter the weather, we ensure your packages are delivered safely...",
      icon: <FontAwesomeIcon icon={faSnowflake} className="w-16 h-16 text-black" />,
    },
  ];
  

  const fleetDetails = [
    "TV / ENTERTAINMENT GOODS",
    "IPHONE / MACBOOK",
    "LARGE TOYS",
    "TRAMPOLINE",
    "DOLLS HOUSE",
    "HOT TUBS & SPAS",
    "HOME APPLIANCES",
  ];

  return (
    <div>
      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center h-[400px] md:h-[600px]"
        style={{ backgroundImage: "url('images/cristmas.png')" }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white">
          <h1 className="text-4xl md:text-7xl xl:text-8xl font-semibold">
            Christmas Delivery
          </h1>
        </div>
      </div>

      {/* Christmas Features Section */}
      <section id="christmas-features" className="py-16 bg-white text-black px-2">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 justify-items-center">
          {christmasFeatures.map((feature, index) => (
            <div
              key={index}
              className="flex flex-col gap-6 items-center text-center mt-6"
            >
              <div className="mb-2 text-red-500">{feature.icon}</div>
              <h3 className="text-xl md:text-2xl font-thin mb-1">{feature.title}</h3>
              <p className="text-zinc-400 max-w-sm text-lg font-thin">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* New Content Section */}
      <section className="md:p-16 bg-white text-black px-3">
        <div className="flex flex-col lg:flex-row justify-center items-center gap-16">
          {/* 24/7 Delivery */}
          <div className="text-center lg:text-left max-w-2xl">
            <h2 className="text-2xl md:text-4xl font-thin mb-4">
              24/7 Christmas Delivery Service
            </h2>
            <p className="text-black mb-4 text-lg text-justify font-thin">
              Looking for a Christmas courier service that can help you deliver
              your presents this holiday season? Look no further than Red
              Rockets Santa's Helpers! We're available 24/7 to make sure your
              presents get where they need to go, no matter how last minute you
              are. And our rates are very reasonable, so you can save yourself
              some money this Christmas.
            </p>
            <p className="text-black text-lg text-justify font-thin">
              Trust our expert drivers Rudolph, Blitzen, Dave, Eric, and Comet.
              They are all highly experienced and will do a great job getting
              your presents to their destination safe and sound.
            </p>
          </div>

          {/* Largest Fleet */}
          <div className="text-center lg:text-left max-w-2xl">
            <h2 className="text-2xl md:text-4xl font-thin mb-4">Largest Fleet</h2>
            <ul className="text-lack mb-4 font-thin">
              {fleetDetails.map((item, index) => (
                <li key={index} className="mb-2">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Last Minute Courier */}
        <div className="mt-16 text-center p-4">
          <h3 className="text-2xl md:text-4xl font-thin mb-4">
            Last Minute Christmas Courier
          </h3>
          <p className="text-black max-w-5xl mx-auto text-lg font-thin">
            Need a last-minute courier? 1UKLogistics is open 24/7/365.
            Our Awesome Elves are here to ensure your presents make it under
            the tree in time for Christmas morning.
          </p>
          <p className="text-black max-w-5xl mx-auto text-lg mt-8 font-thin">
            We have access to over 3000 drivers, allowing us to offer a
            collection time within 60 minutes from quote approval. Your presents
            will be picked up and delivered the same day.
          </p>
        </div>
      </section>
    </div>
  );
}

export default ChristmasDelivery;
